import React, { ReactElement } from 'react';
import Container from '@material-ui/core/Container';

const NotFound404 = (): ReactElement => {
  return (
    <Container>
      <p>Not Found</p>
    </Container>
  );
};

export default NotFound404;
